import React from 'react';
import { injectIntl } from 'react-intl';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {
  Row,
  Col,
  Panel,
  Button,
  Clearfix,
  ListGroup,
  ListGroupItem,
  Modal,
} from 'react-bootstrap';

import Filters from './Filters';
import Clone from './Clone';

@observer
class Options extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.canEdit = props.rootStore.authorizationStore.canEdit;
  }

  render() {
    const { rootStore, intl } = this.props;
    return (
      <div>
        <Button
          onClick={this.handleFilterButtonOnClick}
          style={{ width: '125px' }}
        >
          {intl.formatMessage({ id: 'options' })}
        </Button>
      </div>
    );
  }

  @action
  handleFilterButtonOnClick = () => {
    this.props.rootStore.toggleShowOptionsPanel();
  };
}

export default injectIntl(Options);
